export interface MultiBuy {
  type?: "getting" | string;
  giftedQty?: number;
  promotion: {
    price: number;
  };
}

export interface MultiBuyPricingResult {
  multiBuyQty: number;
  multiBuyItemPrice: number;
  multiBuySavings: number;
  multibuyEnabled: boolean;
}

export function calculateMultiBuyPricing(
  multiBuy: MultiBuy | null | undefined,
  originalPrice: number
): MultiBuyPricingResult {
  let multibuyEnabled =
    !!multiBuy && (multiBuy?.type === "getting" || multiBuy?.giftedQty > 0);
  let multiBuyQty = 1;
  let multiBuyItemPrice = originalPrice;
  let multiBuySavings = 0;

  if (multiBuy) {
    multiBuyQty = multiBuy.giftedQty ?? 1;
    multiBuySavings = originalPrice * multiBuyQty;

    if (multiBuy.promotion.price > 0) {
      multiBuyItemPrice = Math.min(originalPrice, multiBuy.promotion.price);

      multiBuySavings =
        (originalPrice - multiBuy.promotion.price) * multiBuyQty;

      if (multiBuy.promotion.price > originalPrice) {
        multibuyEnabled = false;
      }
    }
  }

  return {
    multiBuyQty,
    multiBuyItemPrice,
    multiBuySavings,
    multibuyEnabled,
  };
}
